export const getAssignedJobApplicationComment = (
  job: { id?: string | null; userId?: string | null },
  applications: Array<{
    jobId?: string | null;
    userId?: string | null;
    coverLetter?: string | null;
  }>,
): string => {
  if (!job.id || !job.userId) return '';

  const application = applications.find(
    (item) => item.jobId === job.id && item.userId === job.userId,
  );

  return application?.coverLetter?.trim() ?? '';
};
